/* eslint-disable no-case-declarations */
import {
  DELETE_HHG_VEHICLES_SUCCESS,
  GET_HHG_ESTIMATE_MOVING_DATES_SUCCESS,
  GET_HHG_ESTIMATES_SUCCESS,
  GET_HHG_ITEMS_SUCCESS,
  GET_HHG_MOVING_DATE_SUCCESS,
  GET_HHG_SEGMENTS_SUCCESS,
  POST_HHG_SEGMENT_SUCCESS,
  POST_HHG_VEHICLES_SUCCESS,
  UPDATE_HHG_ESTIMATE_SUCCESS,
  UPDATE_HHG_SEGMENT_SUCCESS,
  UPDATE_HHG_VEHICLES_SUCCESS,
  POST_HHG_ESTIMATE_SUCCESS
} from '../types/houseHoldGoodsTypes';

const handleHouseHoldGoodsReducer = (draft, action) => {
  if (!draft.authorizationDetails[draft.currentAuthId]) draft.authorizationDetails[draft.currentAuthId] = {};
  if (draft.currentAuthId && !draft.authorizationDetails[draft.currentAuthId].authHouseHoldGoods)
    draft.authorizationDetails[draft.currentAuthId].authHouseHoldGoods = {};

  switch (action.type) {
    case GET_HHG_SEGMENTS_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].hhgSegments = action.response ? action.response : [];
      break;

    case UPDATE_HHG_SEGMENT_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].hhgSegments = action.response;
      break;

    case POST_HHG_SEGMENT_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].hhgSegments = action.response;
      break;

    case GET_HHG_MOVING_DATE_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authHouseHoldGoods.hhgMovingDates = action.response;
      break;

    case GET_HHG_ITEMS_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authHouseHoldGoods.hhgItems = action.response;
      break;

    case GET_HHG_ESTIMATES_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authHouseHoldGoods.hhgEstimates = action.response;
      break;

    case GET_HHG_ESTIMATE_MOVING_DATES_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authHouseHoldGoods.hhgEstimateMovingDates = action.response;
      break;

    case UPDATE_HHG_ESTIMATE_SUCCESS:
      const updateEstimateSegmentIndex = draft.authorizationDetails[draft.currentAuthId].hhgSegments.findIndex((hhgs) => hhgs.segmentInfo.hhgSegmentId === action.payload.estimateInfo.hhgSegmentId);
      draft.authorizationDetails[draft.currentAuthId].hhgSegments[updateEstimateSegmentIndex].estimates = action.response;
      break;

    case POST_HHG_ESTIMATE_SUCCESS:
      const postEstimateSegmentIndex = draft.authorizationDetails[draft.currentAuthId].hhgSegments.findIndex((hhgs) => hhgs.segmentInfo.hhgSegmentId === action.payload.hhgSegmentId);
      draft.authorizationDetails[draft.currentAuthId].hhgSegments[postEstimateSegmentIndex].estimates = action.response;
      break;

    // case GET_HHG_VEHICLES_SUCCESS:
    //   draft.authorizationDetails[draft.currentAuthId].authHouseHoldGoods.hhgSegmentVehicles = action.response;
    //   break;

    case UPDATE_HHG_VEHICLES_SUCCESS: 
      const updateSegmentIndex = draft.authorizationDetails[draft.currentAuthId].hhgSegments.findIndex((hhgs) => hhgs.segmentInfo.hhgSegmentId === action.payload.hhgSegmentId);
      draft.authorizationDetails[draft.currentAuthId].hhgSegments[updateSegmentIndex].vehicles = action.response;
      break;

    case POST_HHG_VEHICLES_SUCCESS:
      const postSegmentIndex = draft.authorizationDetails[draft.currentAuthId].hhgSegments.findIndex((hhgs) => hhgs.segmentInfo.hhgSegmentId === action.payload.hhgSegmentId);
      draft.authorizationDetails[draft.currentAuthId].hhgSegments[postSegmentIndex].vehicles = action.response;
      break;

    case DELETE_HHG_VEHICLES_SUCCESS:
      const deleteSegmentIndex = draft.authorizationDetails[draft.currentAuthId].hhgSegments.findIndex((hhgs) => hhgs.segmentInfo.hhgSegmentId === action.context.hhgSegmentId);
      draft.authorizationDetails[draft.currentAuthId].hhgSegments[deleteSegmentIndex].vehicles = action.response;
      break;

    default:
      break;
  }

  return draft;
};

export default handleHouseHoldGoodsReducer;
